import moment, { Moment } from 'moment/moment'

export function todayPlusTwoDays(locale: string): Moment {
  return today(locale).add(2, 'day')
}

export function today(locale: string): Moment {
  return moment().startOf('day').locale(locale)
}

export function inOneYear(locale: string): Moment {
  return today(locale).clone().add(12, 'months').locale(locale)
}

export function dayIsOutsideBookingWindow(locale: string): (day: Moment) => boolean {
  return day => day.isBefore(todayPlusTwoDays(locale)) || day.isSameOrAfter(inOneYear(locale))
}